<template>
  <layout-main-inner title="订单">
    <template slot="action">
      <!-- <create-order-btn /> -->
    </template>
    <layout-card-wrap>
      <order-table-all
        ref="table_1"
        :edit="false" />
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
// import CreateOrderBtn from './busi/create-order-btn.vue'
import OrderTableAll from './order-table-all.vue'

export default {
  name: 'QueryOrdersList',
  components: { OrderTableAll },
  props: {},
  data() {
    return {
      activeTab: '1'
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    handleClick(e) {
      console.log(e.name)
      this.$refs['table_' + e.name].fetchList()
    }
  }
}
</script>
